import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    template: '<router-outlet></router-outlet>',
    selector: 'plain-router-outelet',
    standalone: true,
    imports: [RouterOutlet]
})
export class PlainRouterOutletComponent {}
